<template>
  <section :id="$options.name" class="facilities" ref="facilities">
    <p class="facilities__subtitle">Alcuni servizi potrebbero essere a pagamento</p>
    <ul class="facilities__list">
      <li
        class="facilities__list-item"
        v-for="(facility, facility_index) in details.facilities"
        :key="_uid + 'facility' + facility_index"
      >
        <facility :item="facility" />
      </li>
    </ul>
    <span class="facilities__show" v-b-modal="'modal_facilities'">vedi i servizi</span>
    <vb-modal
      :vb_options="{
        id: 'modal_facilities',
        title: details.name.it + ': Servizi',
        size: is_mobile() ? 'lg' : 'xl',
        centered: true,
        hide_footer: true
      }"
    >
      <ul class="facilities__modal">
        <li
          class="facilities__modal-item"
          v-for="(facility, facility_index) in details.facilities"
          :key="_uid + 'facility' + facility_index"
        >
          <facility :item="facility" />
        </li>
      </ul>
    </vb-modal>
    <spoken-langs :languages="details.spoken_languages" />
  </section>
</template>

<script>
import Facility from "@bookingv3/components/blocks/facility"
import SpokenLangs from "@bookingv3/components/blocks/detail/spoken-langs"

export default {
  inheritAttrs: false,
  name: 'facilities',

  components: {
    'facility': Facility,
    'spoken-langs': SpokenLangs,
  },

  props: {
    details: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .facilities {
    @extend %section;
    @extend %section_margin;

    &__subtitle {
      font-size: $font-size-md;


      @include media-breakpoint-up(lg){
        margin-bottom: $grid-gutter-width;
      }
    }

    &__list {
      padding: 0;
      margin: 0;

      @include media-breakpoint-down(lg) {
        display: block;
      }

      @include media-breakpoint-up(lg) {
        display: flex;
        flex-wrap: wrap;
        height: 245px;
        overflow: hidden;
      }

      &-item {
        list-style: none;
        padding: 3px 0;

        @include media-breakpoint-up(lg) {
          line-height: normal;
          padding: 5px 30px 5px 0;
          margin: 3px 5px 3px 0;
          width: 32%;
          display: flex;
          align-items: center;
        }
      }
    }

    &__modal {
      @extend .facilities__list;
      height: auto;
      overflow: auto;

      &-item {
        @extend .facilities__list-item;
      }
    }

    &__show {
      display: block;
      color: $info;
      text-decoration: underline;
      font-size: $font-size-md;
      cursor: pointer;
      justify-content: flex-end;

      @include media-breakpoint-up(lg){
        margin-top: 15px;
      }
    }
  }

</style>